/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/*
 *  Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.15.0
 * @since 1.0.0
 */
import { useEffect } from 'react';

import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Route, RouteChildrenProps, Switch } from 'react-router-dom';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectTranslationCommon } from '../../modules/internationalization/intSelectors';
import ICommonTranslation from '../../modules/internationalization/types/common';
import { logBusinessEvent } from '../../modules/logging/loggingActions';
import { ELogBusinessEventName, ELogBusinessEventType } from '../../modules/logging/loggingConstants';
import { ILogBusinessEventPayload } from '../../modules/logging/loggingTypes';
import { IRootReducer } from '../../reducers/rootReducer';
import { openRoute } from '../../routes/constants/externalRoutes';
import { CLIENT_ID, IRouteParams, RoutePath, RoutePathOld } from '../../routes/constants/routesConstants';
import { icons } from '../../theme';
import ErrorPage from './ErrorPage';

export const PageNotFound = (props: IConnectedProps & IDispatchProps & Partial<RouteComponentProps>) => {
    useEffect(() => {
        props.logBusinessEvent({
            eventName: ELogBusinessEventName.B2B_EVENT_ERROR,
            type: ELogBusinessEventType.common,
        });
    }, []);

    return (
        <Switch>
            <Route path={RoutePathOld.subscriberIdInfo}>
                {
                    (p: RouteChildrenProps<IRouteParams>) => {
                        const id = p.match?.params.clientId || '';
                        const url = RoutePath.subscriberId.replace(CLIENT_ID, id);
                        openRoute(url);
                    }
                }
            </Route>
            <Route path="**">
                <ErrorPage
                    src={icons.errorDeliveryImage3x}
                    text={props.translation.error.ui.text}
                    title={props.translation.error.codes['page.not.found']}
                />
            </Route>
        </Switch>
    );
};

export interface IConnectedProps {
    translation: ICommonTranslation;
}

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    translation: makeSelectTranslationCommon(),
});

export interface IDispatchProps {
    logBusinessEvent: (payload: ILogBusinessEventPayload) => void;
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    logBusinessEvent: (payload) => dispatch(logBusinessEvent(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageNotFound);
